import React from "react";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <section class="section service" aria-labelledby="service-label">
      <div class="container">
        <p class="section-subtitle" id="service-label">
          What We Offer?
        </p>

        <h2 class="h2 section-title">
          Our Services are designed to ensure a safe and comfortable journey.
        </h2>

        <ul class="grid-list">
          <li>
            <div className="service-card">
              <div className="card-icon">
                <ion-icon
                  name="car-sport-outline"
                  aria-hidden="true"
                ></ion-icon>
              </div>

              <h3 className="h4 card-title">Chauffeured and Self-Drive</h3>

              <p className="card-text">
                Choose from our range of chauffeured or self-drive car rentals.
                We offer flexible options to fit your travel needs.
              </p>

              <Link to="/about" className="btn-text">
                <span className="span">Learn More</span>

                <ion-icon
                  name="arrow-forward-outline"
                  aria-hidden="true"
                ></ion-icon>
              </Link>
            </div>
          </li>

          <li>
            <div className="service-card">
              <div className="card-icon">
                <ion-icon name="airplane-outline" aria-hidden="true"></ion-icon>
              </div>

              <h3 className="h4 card-title">Pick and Drop-offs</h3>

              <p className="card-text">
                We offer reliable pick and drop-off services from Kisumu Airport
                to any destination within Western Kenya, ensuring a smooth and
                timely transfer.
              </p>

              <Link to="/about" className="btn-text">
                <span className="span">Learn More</span>

                <ion-icon
                  name="arrow-forward-outline"
                  aria-hidden="true"
                ></ion-icon>
              </Link>
            </div>
          </li>
          <li>
            <div className="service-card">
              <div className="card-icon">
                <ion-icon name="business-outline" aria-hidden="true"></ion-icon>
              </div>

              <h3 className="h4 card-title">Long-term Car Hire</h3>

              <p className="card-text">
                We provide long-term car hire solutions for businesses, offering
                a wide range of vehicles for your corporate transportation
                needs. Book a ride with us today.
              </p>

              <Link to="/about" className="btn-text">
                <span className="span">Learn More</span>

                <ion-icon
                  name="arrow-forward-outline"
                  aria-hidden="true"
                ></ion-icon>
              </Link>
            </div>
          </li>
          <li>
            <div class="service-card">
              <div class="card-icon">
                <ion-icon
                  name="pie-chart-outline"
                  aria-hidden="true"
                ></ion-icon>
              </div>

              <h3 class="h4 card-title">Affordable Rates</h3>

              <p class="card-text">
                We offer competitive pricing with no hidden fees. Know exactly
                what you're paying for before you ride. We match the value of
                your money with quality services.
              </p>

              <Link to="/about" className="btn-text">
                <span class="span">Learn More</span>

                <ion-icon
                  name="arrow-forward-outline"
                  aria-hidden="true"
                ></ion-icon>
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Services;
